var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('GlobalNavbar'),_c('transition',{attrs:{"name":"fadePage","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath,attrs:{"id":"appContent"}})],1),_c('GlobalFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }